/**
 * SMECredentials — /sme/credentials
 */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import client from "@/api/client";
import ClimateCredentialsPanel from "@/components/ClimateCredentialsPanel";
import { PageHeader, SectionCard, CTAButton } from "@/components/ds";

export default function SMECredentials() {
  const navigate = useNavigate();
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  const load = () => {
    setLoading(true);
    client.get("/credentials/sme")
      .then(r => { setData(r.data); setError(null); })
      .catch(e => { setError(e); })
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="p-6 lg:p-8 space-y-6">
      <PageHeader
        label="SME WORKSPACE"
        title="Climate & Circularity Credentials"
        subtitle="7-section institutional document — auditable, evidence-linked, decision-grade"
        backUrl="/sme/overview"
        backLabel="SME Workspace"
      />

      {error ? (
        <SectionCard>
          <div className="py-10 text-center">
            <p className="text-sm font-semibold text-amber-700">Credentials not yet available</p>
            <p className="text-xs text-slate-500 mt-1 mb-4">
              Calculate at least one monthly period to generate credentials.
            </p>
            <CTAButton variant="action" onClick={() => navigate("/sme/monthly/inputs")}>
              Enter Monthly Data →
            </CTAButton>
          </div>
        </SectionCard>
      ) : (
        <ClimateCredentialsPanel data={data} loading={loading} onRefresh={load}
          workspace="sme" periodLabel={data?.period} />
      )}
    </div>
  );
}
